/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'breakpoints',
    'pip-events',
    'javascript-debounce'
],
function(
    $,
    breakpoints,
    pipEvents,
    debounce
) {

    var DOM = {
        table: '.specs__table',
        group: '.specs__group'
    }
    
    function initEventListeners() {
        $(window).off('resize.specs');
        $(window).on('resize.specs', function () {
            debounce(setSectionHeight(DOM.table), 250);
        });
        pipEvents.tabs.specsTabSelected.off('.specsTabSelected');
        pipEvents.tabs.specsTabSelected.on('.specsTabSelected', function() {
            setSectionHeight(DOM.table);
        })
    }

    var template = '<div class="specs__group placeholder col-12 col-lg-6">' +
                        '<div class="col-6 specs__cell specs__cell--label">&nbsp;</div>' +
                        '<div class="col-6 specs__cell">&nbsp;</div>' +
                    '</div>';

    function setSectionHeight(table) {
        if (breakpoints.isActiveBreakpointEqualToOrLargerThan('Large')) {
            $(table).each(function () {
                var specGroups = $(this).find(DOM.group);
                var groupCount = specGroups.length;
                var middleRow = Math.ceil(groupCount / 2);

                if (groupCount % 2) {
                    $(this).append(template);
                    specGroups.push($(this).find(DOM.group).last()[0]);
                }

                var firstHalfOfSpecGroups = specGroups.slice(0, Math.floor(specGroups.length / 2));
                var secondHalfOfSpecGroups = specGroups.slice(Math.floor(specGroups.length / 2));

                var leftSideOfTableHeights = getIndividualRowHeight(firstHalfOfSpecGroups);
                var rightSideOfTableHeights = getIndividualRowHeight(secondHalfOfSpecGroups);

                specGroups.each(function (index, el) {
                    var heightIndex = index <= middleRow ? index : index - middleRow;
                    var height = Math.max(leftSideOfTableHeights[heightIndex], rightSideOfTableHeights[heightIndex]);
                    leftSideOfTableHeights[heightIndex] = height;
                    rightSideOfTableHeights[heightIndex] = height;
                    $(el).css('min-height', height);
                });

                var leftSideTotalHeight = getTotalColumnHeight(leftSideOfTableHeights);
                var rightSideTotalHeight = getTotalColumnHeight(rightSideOfTableHeights);

                $(this).css('height', Math.max(leftSideTotalHeight, rightSideTotalHeight));
            });
        }
    }

    function getIndividualRowHeight(arrayOfRows) {
        return arrayOfRows.map(function () {
            $(this).css('min-height', 0);
            return $(this).outerHeight() + 1;
        });
    }

    function getTotalColumnHeight(arrayOfRowHeights) {
        return arrayOfRowHeights.toArray().reduce(function (sum, value) {
            return sum + value;
        }, 0);
    }

    return {
        init: function () {
            setSectionHeight(DOM.table);
            initEventListeners();
        }
    }
});

}.call(window));